export default "__VITE_ASSET__DoHXV0bP__"